import { BetterDocRejectionReason, BetterDocRejectionReasonValues } from "@/types/__generated__/union-types"

type BetterDocRejectionReasonItem = {
  value: BetterDocRejectionReason
  labelKey: string
  testId: string
}

const BETTER_DOC_REJECTION_REASON_ITEMS: BetterDocRejectionReasonItem[] = [
  {
    value: "PATIENT_REFUSES_TO_USE_BETTER_DOC",
    labelKey: "episodeOfCare.betterDoc.rejectionReasons.PATIENT_REFUSES_TO_USE_BETTER_DOC",
    testId: "better-doc-rejection-reason-patient-refuses",
  },
  {
    value: "BETTER_DOC_CHOSE_CARE_PROVIDER_BEFOREHAND",
    labelKey: "episodeOfCare.betterDoc.rejectionReasons.BETTER_DOC_CHOSE_CARE_PROVIDER_BEFOREHAND",
    testId: "better-doc-rejection-reason-chosen-beforehand",
  },
]

const isBetterDocRejectionReason = (value: string): value is BetterDocRejectionReason =>
  BetterDocRejectionReasonValues.some((candidate) => candidate === value)

export { BETTER_DOC_REJECTION_REASON_ITEMS, isBetterDocRejectionReason }
